import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SearchModalService {
  private readonly isOpenModal$ = new ReplaySubject<boolean>();

  setIsOpenModal(context: boolean): void {
    this.isOpenModal$.next(context);
  }

  getIsOpenModal$(): Observable<boolean> {
    return this.isOpenModal$;
  }
}
